export const isMobile: boolean = window.matchMedia('only screen and (max-width: 576px)').matches;
export const isTabletOrSmaller: boolean = window.matchMedia('only screen and (max-width: 1024px)').matches;
